<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">
    @for (item of viewModel; track item) {
        <ng-container
            [ngTemplateOutletContext]="{name: item.name, description: item.value}"
            [ngTemplateOutlet]="panel"/>
    }
    @if (!viewModel.length) {
        <ui-kit-empty-state backgroundColor="light"
                            class="w-100"
                            spinnerIds="commonClassification"
                            [title]="'i18n_af_emptyStateTitleNoData'"
                            [subtitle]="authHolderService.hasAccess(['npck-admin']) ? 'i18n_af_emptyStateSubtitleAddData' : 'i18n_af_emptyStateSubtitleNoData'"
                            [buttonLabel]="authHolderService.hasAccess(['npck-admin']) ? 'i18n_af_buttonAddData' : undefined"
                            (clickListener)="authHolderService.hasAccess(['npck-admin']) && clickListener.emit()"
                            icon="ic_empty_state_no_data"/>
    }
</div>

<ng-template #panel let-name='name' let-description="description">
    <div class="panel-container">
        <div class="c-primary-gray-600">{{ ('i18n_af_classificationPanelTitle#' + name) | translate }}</div>
        <div class="description" [innerHtml]="description | safeHtml"></div>
    </div>
</ng-template>
